import {observer} from 'mobx-react-lite'
import {IconButton} from '@mui/material'
import {messages} from '../../translations'
import React from 'react'
import {makeStyles} from '@oc/styles'
import {RKChangesAfterLastDeployDialog} from './RKChangesAfterLastDeployDialog'
import {RkLastDataChangeState} from './RkLastDataChangeState'
import {TrackChanges} from '@mui/icons-material'

const useStyles = makeStyles({
    button: {
        padding: 0
    }
})

interface RkLastDataChangeProps {
    accountId: string
    readykitId: string
}

function _RkLastDataChange(props: RkLastDataChangeProps) {
    const {classes} = useStyles()
    const [state] = React.useState(() => new RkLastDataChangeState())

    React.useEffect(() => {
        const anyWindow = window as any
        if (anyWindow.Cypress) {
            state.connectCypress(props.accountId, props.readykitId)
            anyWindow.lastDataChangeState = state
        } else {
            state.connect(props.accountId, props.readykitId)
        }

        return state.disconnect
    }, [state, props.accountId, props.readykitId])

    if (!state.isConnected || !state.hasChangesAfterDeployment) {
        return null
    }

    return (
        <>
            <IconButton
                onClick={state.openDialog}
                data-cy="changes-on-rk-button"
                title={messages.getText('tooltips', 'trackChanges')}
                color="inherit"
                className={classes.button}
            >
                <TrackChanges data-cy="changes-on-rk-button-icon" color="inherit" />
            </IconButton>
            <RKChangesAfterLastDeployDialog state={state} />
        </>
    )
}
export const RkLastDataChange = observer(_RkLastDataChange)
